import {
  ActionList,
  ActionListItem,
  Divider,
  GridItem,
  Link,
  PrimaryTag,
  Text,
} from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import qs from "qs";
import React from "react";
import { Trans } from "react-i18next";
import { useLocation } from "react-router-dom";

import { EmploymentHistoryModal } from "./EmploymentHistoryModal";
import { getEmployerDate } from "./utils";

type EmploymentHistoryListProps = {
  employers: components["schemas"]["EmploymentCheckFieldValue"][];
  onSave: (
    employer: components["schemas"]["EmploymentCheckFieldValue"],
    index: number
  ) => void;
  onDelete: (index: number) => void;
};

export function EmploymentHistoryList({
  employers,
  onSave,
  onDelete,
}: EmploymentHistoryListProps) {
  const sortedEmployers = employers
    .map((employer, i) => ({ ...employer, index: i }))
    .sort(({ end_date }) => (end_date ? 1 : -1));

  const location = useLocation();
  const params = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const selectedEmployer = params.employer;

  return (
    <GridItem>
      <ActionList>
        {sortedEmployers.map((employer) => (
          <React.Fragment key={employer.index}>
            <ActionListItem
              testID="employer-list"
              title={employer.company_name}
              tag={
                !employer.end_date && (
                  <PrimaryTag type="subtle">
                    <Trans>Current</Trans>
                  </PrimaryTag>
                )
              }
              trailing={
                <EmploymentHistoryModal
                  defaultOpen={
                    !!selectedEmployer && selectedEmployer === employer.id
                  }
                  index={employer.index}
                  onSave={onSave}
                  employer={employer}
                  onDelete={() => onDelete(employer.index)}
                  trigger={
                    <Link
                      linkStyle="monochrome"
                      textStyle="global/body-secondary"
                      testID="employment-history-edit-history-button"
                    >
                      <Trans>Edit</Trans>
                    </Link>
                  }
                />
              }
            >
              <Text style="global/body-secondary" color="text-weak">
                {getEmployerDate(employer)}
              </Text>
            </ActionListItem>
            <Divider />
          </React.Fragment>
        ))}
      </ActionList>
    </GridItem>
  );
}
